import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { EventResource } from 'src/app/interfaces/event-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-smartquick',
  templateUrl: './smartquick.component.html',
  styleUrls: ['./smartquick.component.scss']
})
export class SmartquickComponent implements OnInit {
  /**
   * The MatStepper to show the Progress 
   */
  @ViewChild('stepper') stepper: MatStepper;
  /**
   * has the Page been loaded
   */
  finishedLoading: boolean = false;
  /**
   * The Current Event 
   */
  currentEvent: EventResource;
  /***
   * The Current page of Events
   */
  page = null;
  /**
   *  Page Meta Data
   */
  pageComponents = {
    pageIndex: 0,
    pageSize: 8
  }
  dataSource: MatTableDataSource<EventResource>;
  /**
   * The Form to filter the Events
   */
  addFormEvent: UntypedFormGroup;
  /**
   * The Form to Enter the Code
   */
  voucherForm: UntypedFormGroup;
  /**
   * The Current Event
   */
  selectedEvent = -1;
  /**
   * The Table of Events 
   */
  displayedColumns = ['menu', 'user'];
  /**
   * The Codes the user has entered
   */
  enterdVoucherCodes = [];
  /**
   * constructor
   * Init the Form
   * @param eventService 
   * @param overlay 
   * @param fb 
   * @param router 
   * @param route 
   */
  constructor(
    private eventService: EventService,
    private overlay: OverlayService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute) {
    this.addFormEvent = this.fb.group({
      searchTerm: [''],
      event: ['', [Validators.required]],
    })
    this.voucherForm = this.fb.group({
      forceAttendance: [''],
      code: ['', []],
    })
    this.route.queryParams.subscribe({
      next: params => {
        if (params['eventPublicId']) {
          this.eventService.getEvent(params['eventPublicId']).subscribe({
            next: (event: EventResource) => {
              this.addFormEvent.patchValue({
                event: event
              })
              this.currentEvent = event;
              this.stepper.next();
            },
            error: err => {
              this.overlay.openSnackBar("Fehler beim Laden des Events.", 'error')
            }
          })
        }

      }
    })
  }
  /**
   * ngOnInit
   * Search for the Events
   */
  ngOnInit() {
    this.eventService.searchForEvents(this.pageComponents.pageIndex, this.pageComponents.pageSize, ["CREATED", "ACTIVE", "PREVIEW", "HIDDEN", "EXPIRED"], ["MONETARY", "SERVICE_PLUS"], null, null).subscribe({
      next: (result: PagedResources<EventResource>) => {
        this.page = result.page;
        this.dataSource = new MatTableDataSource(result.content);
        this.finishedLoading = true;
      },
      error: err => {
        console.log("error: ", err);
        this.overlay.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
      }
    })
  }

  /**
   * Select an Event as the current active Event, that vouchers are used on
   * @param event 
   */
  setActiveEvent(event: EventResource) {
    this.currentEvent = event;
    this.addFormEvent.patchValue({
      event: event
    })
  }
  /**
   * Filter the Events
   */
  filterEvents() {
    this.eventService.searchForEvents(0, 12, ["CREATED", "ACTIVE", "PREVIEW", "HIDDEN", "EXPIRED"], ["MONETARY", "SERVICE_PLUS"], null, this.addFormEvent.value.searchTerm).subscribe((events: PagedResources<EventResource>) => {
      this.page = events.page
      this.dataSource = new MatTableDataSource(events.content);
    })
  }
  /**
   * Load the Page of Events 
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageComponents.pageIndex = event.pageIndex;
    this.pageComponents.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.selectedEvent = -1;
        this.addFormEvent.patchValue({
          event: null
        })
        return this.search(event.pageIndex, event.pageSize);
      })
  }
  /**
   * Search for Events
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.eventService.searchForEvents(pageIndex, pageSize, ["CREATED", "ACTIVE", "PREVIEW", "HIDDEN", "EXPIRED"], ["MONETARY", "SERVICE_PLUS"], null, null).subscribe((events: PagedResources<EventResource>) => {
      this.page = events.page
      this.dataSource = new MatTableDataSource(events.content);
    })
  }
  /**
   * Send the Voucher to the Backend
   * @param keyEvent 
   * @returns 
   */
  enterVoucherCode(keyEvent: KeyboardEvent) {
    //enter pressed 
    if (keyEvent.key === "Enter") {
      this.voucherForm.markAllAsTouched();
      if (this.voucherForm.invalid) {
        return;
      }
      if (this.voucherForm.value.code) {
        this.eventService.quickAttendance(this.currentEvent.publicId, this.voucherForm.value.code, this.voucherForm.value.forceAttendance).subscribe({
          next: () => {
            this.voucherForm.reset()
          },
          error: err => {
            console.log(err)
            if (err.error.hurdle != '') {
              this.overlay.openSnackBar(`Fehler: ${err.error.hurdle}`, 'error');
            } else {
              this.overlay.openSnackBar(`Fehler beim Einlösen des Gutscheins`, 'error');
            }
          }
        })
      }
    }
  }

/**
 * Send the Code to the Backend and Create a Resevation
 */
  enterVoucherCodeViaBtn() {
    if (this.voucherForm.value.code) {
      this.eventService.quickAttendance(this.currentEvent.publicId, this.voucherForm.value.code, this.voucherForm.value.forceAttendance).subscribe({
        next: () => {
          this.overlay.openSnackBar(`Gutschein erfolgreich eingelöst`, 'error');
          this.voucherForm.reset()
        },
        error: err => {
          console.log(err)
          if (err.error.hurdle != '') {
            this.overlay.openSnackBar(`Fehler: ${err.error.hurdle}`, 'error');
          } else {
            this.overlay.openSnackBar(`Fehler beim Einlösen des Gutscheins`, 'error');
          }
        }
      })
    }
  }

/**
 * delte a VoucerKey
 * @param key 
 */
  delteVoucerKey(key) {
    this.enterdVoucherCodes.splice(this.enterdVoucherCodes.indexOf(key), 1)
  }

  /**
   * send the VoucherCodes to the backend and create a reservation
   */
  quickAttendance() {
    this.enterdVoucherCodes.forEach(element => {
      this.eventService.quickAttendance(this.currentEvent.publicId, element, false).subscribe({
        next: res => {
          console.log(res)
        },
        error: err => {
          console.log(err)
          if (err.error.hurdle != '') {
            element.error = err.error.hurdle;
            this.overlay.openSnackBar(`Fehler: ${err.error.hurdle}`, 'error');
          } else {
            element.error = "Unbekannter Fehler"
            this.overlay.openSnackBar(`Fehler beim Einlösen des Gutscheins`, 'error');
          }
        }
      })
    });
  }
}
